var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-arrow d-flex justify-center align-center",style:(_vm.style),on:{"click":_vm.buttonAction}},[_c('img',{attrs:{"src":require("../../assets/img/arrows/flecha-siguiente_2.svg"),"alt":"next"}}),_c('div',{staticClass:"position-absolute"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }